import { ApolloError } from "@apollo/client";

import { AiInterviewerVideoMode, AiInterviewQuestion } from "../../graphql";

export type AiInterviewerVideoSetting = AiInterviewerVideoMode;

export type EmailConfig = {
  fromName: string;
  fromEmail: string;
  replyTo: string;
  subject: string;
  bodyHtml: string;
};

export const DEFAULT_INVITATION_SMS_MESSAGE =
  "Hi {{candidate_name}}, you're invited to complete a short AI interview for the {{position_name}} role at {{organization_name}}. Start here: {{interview_link}}";

export type AiInterviewerFormValues = {
  name: string;
  displayName: string;
  positionId?: string; // Only used for ATSless orgs
  questions: AiInterviewQuestion[];
  followups?: string[];
  positionInfo: string;
  introduction: string;
  closing: string;
  jobDescription: string;
  inviteExpirationDays: number;
  reminderDays: number;
  reminderEmailEnabled: boolean;
  completionEmailEnabled: boolean;
  verbatim: string; // string because of radio button handling
  customQuestionWeightsEnabled: boolean;
  videoSetting: AiInterviewerVideoSetting;
  emailConfig: {
    invitation: EmailConfig;
    reminder: EmailConfig;
    completion: EmailConfig;
  };
  invitationSmsEnabled: boolean;
  invitationSmsMessage: string;
  completionNotificationEmails: string[]; // ATSless: emails to notify on interview completion
};

export interface MutationResult<T> {
  mutation: T;
  loading: boolean;
  error?: ApolloError;
}

// Placeholder types/values for future membership data
export type AiInterviewerMembershipRole = "EDITOR" | "VIEWER";
export interface AiInterviewerMembershipUser {
  id: string;
  firstName: string | null;
  lastName: string | null;
  email: string;
}
export interface AiInterviewerMembership {
  id: string;
  role: AiInterviewerMembershipRole;
  user: AiInterviewerMembershipUser;
}
